module.exports = __webpack_public_path__ + "img/share7.39305f57.png";